module.exports = __webpack_public_path__ + "location_white.0556aa72cfc612ac26b3.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/location_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/location_white.svg
// module chunks = styles